// src/api/userApi.js
import { userMockData } from "./mock/userData";

export const getDataByAll = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(userMockData);
    }, 600);
  });
};